import { useState, useEffect } from "react";

const FOOD_ICONS = ["🍲", "🥟", "🍖", "🥩", "🍷", "🥗", "🍞", "🧆", "🥘", "🍰"];

export default function LoadingScreen({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [fading, setFading] = useState(false);
  const [allLit, setAllLit] = useState(false);

  useEffect(() => {
    const duration = 2600;
    const interval = 30;
    const step = 100 / (duration / interval);
    const timer = setInterval(() => {
      setProgress((prev) => {
        const next = prev + step;
        if (next >= 100) {
          clearInterval(timer);
          // All icons lit — hold for a moment, then fade
          setAllLit(true);
          setTimeout(() => setFading(true), 800);
          setTimeout(() => onFinish(), 1500);
          return 100;
        }
        return next;
      });
    }, interval);
    return () => clearInterval(timer);
  }, [onFinish]);

  // Icons light up evenly across progress, ensure all 10 are lit at 100%
  const activeCount = progress >= 100
    ? FOOD_ICONS.length
    : Math.floor((progress / 95) * FOOD_ICONS.length);

  return (
    <div
      data-testid="loading-screen"
      className={`fixed inset-0 z-[9999] bg-[#02120D] flex flex-col items-center justify-center transition-opacity duration-600 ${
        fading ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      {/* Name */}
      <div className="mb-12 px-4 text-center">
        <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl md:text-6xl font-semibold text-[#F0FDF4] tracking-tight drop-shadow-2xl loading-title">
          Veranda
        </h1>
        <p className="font-['Playfair_Display'] text-2xl sm:text-3xl md:text-4xl font-medium text-[#EAB308] tracking-tight mt-2">
          pod Soutokem
        </p>
      </div>

      {/* Food icons bar */}
      <div className="flex items-center gap-3 sm:gap-4 mb-8">
        {FOOD_ICONS.map((icon, i) => (
          <span
            key={i}
            className={`text-xl sm:text-2xl transition-all duration-400 ${
              i < activeCount
                ? `opacity-100 scale-110 food-icon-active ${allLit ? "food-icon-glow" : ""}`
                : "opacity-15 scale-90 grayscale"
            }`}
            style={{ transitionDelay: `${i * 30}ms` }}
          >
            {icon}
          </span>
        ))}
      </div>

      {/* Progress bar */}
      <div className="w-64 sm:w-80 h-[3px] bg-[#1D4133] rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#EAB308] to-[#facc15] rounded-full transition-all duration-100 ease-out"
          style={{ width: `${Math.min(progress, 100)}%` }}
        />
      </div>

      {/* Tagline */}
      <p className="text-xs text-[#94A3B8]/50 mt-6 tracking-widest uppercase">
        Restaurace & Jídelna
      </p>
    </div>
  );
}
